import { apiFetch } from '../api-client';

export interface Branch { id: string; name: string; address: string; phone: string | null }
export interface Bank {
  id: string; bankName: string; bankCode: string; colorHex: string;
  account: string; holder: string; branch: string | null; isDefault: boolean;
  openingBalance: number;
  disbursed: number;
  balance: number;
}
export type BankInput = Omit<Bank, 'id' | 'openingBalance' | 'disbursed' | 'balance'> & { openingBalance?: number };
export interface Company {
  id: string; name: string; shortName: string | null; taxCode: string;
  foundedDate: string | null; license: string | null; licenseIssuer: string | null;
  entityType: string | null; charteredCapital: number;
  address: string | null; phone: string | null; email: string | null; website: string | null; fax: string | null;
  legalRepName: string | null; legalRepRole: string | null; legalRepCccd: string | null; legalRepDob: string | null;
  kttName: string | null; kttCert: string | null; kttCccd: string | null; kttDob: string | null;
  accountingRegime: string; vasCompliance: string; reportingCurrency: string;
  vatPeriod: string; vatMethod: string; cit: number;
  branches: Branch[];
  banks: Bank[];
}
export const companyApi = {
  get: () => apiFetch<Company | null>('/api/company'),
  patch: (body: Partial<Company>) => apiFetch<Company>('/api/company', { method: 'PATCH', body: JSON.stringify(body) }),
  addBranch: (body: Omit<Branch, 'id'>) => apiFetch<Branch>('/api/company/branches', { method: 'POST', body: JSON.stringify(body) }),
  patchBranch: (id: string, body: Partial<Branch>) => apiFetch<Branch>(`/api/company/branches/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  removeBranch: (id: string) => apiFetch<{ ok: true }>(`/api/company/branches/${id}`, { method: 'DELETE' }),
  addBank: (body: BankInput) => apiFetch<Bank>('/api/company/banks', { method: 'POST', body: JSON.stringify(body) }),
  patchBank: (id: string, body: Partial<BankInput>) => apiFetch<Bank>(`/api/company/banks/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  removeBank: (id: string) => apiFetch<{ ok: true }>(`/api/company/banks/${id}`, { method: 'DELETE' }),
};
